import React, { useState, useEffect } from 'react';

const QuantityControl = ({ initialQuantity = 1, onQuantityChange }) => {
    const [quantity, setQuantity] = useState(initialQuantity);

    useEffect(() => {
        // initialQuantity prop'u değiştiğinde state'i güncelle
        setQuantity(initialQuantity);
    }, [initialQuantity]);

    const incrementQuantity = () => {
        const newQuantity = quantity + 1;
        setQuantity(newQuantity);
        onQuantityChange && onQuantityChange(newQuantity);
    };

    const decrementQuantity = () => {
        if (quantity > 0) {
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            onQuantityChange && onQuantityChange(newQuantity);
        }
    };

    return (
        <div className="quantity-control-wrapper">
            <div className="d-flex align-items-center justify-content-start">
                <div className="quantity-control d-flex align-items-center border border-gray-200 rounded-4 overflow-hidden bg-white">
                    <button
                        type="button"
                        onClick={decrementQuantity}
                        className="quantity-btn quantity-minus d-flex align-items-center justify-content-center border-0 bg-white text-gray-600 hover-bg-main-600 hover-text-white transition-all"
                        disabled={quantity <= 1}
                        style={{ minWidth: '36px', minHeight: '36px' }}
                    >
                        <i className="ph ph-minus" style={{ fontSize: '14px' }} />
                    </button>
                    <div className="quantity-display d-flex align-items-center justify-content-center px-3 bg-white border-start border-end border-gray-200">
                        <span className="text-gray-900 fw-medium text-sm">
                            {quantity} Adet
                        </span>
                    </div>
                    <button
                        type="button"
                        onClick={incrementQuantity}
                        className="quantity-btn quantity-plus d-flex align-items-center justify-content-center border-0 bg-white text-gray-600 hover-bg-main-600 hover-text-white transition-all"
                        style={{ minWidth: '36px', minHeight: '36px' }}
                    >
                        <i className="ph ph-plus" style={{ fontSize: '14px' }} />
                    </button>
                </div>
            </div>

            <style jsx>{`
                .quantity-control-wrapper {
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }

                .quantity-control {
                    border-radius: 8px !important;
                    transition: all 0.2s ease;
                    border: 1px solid #e0e0e0 !important;
                    background: white !important;
                }

                .quantity-btn {
                    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    background: white !important;
                    color: #6c757d !important;
                }

                .quantity-btn:hover:not(:disabled) {
                    background: var(--main-600, #299E60) !important;
                    color: white !important;
                }

                .quantity-btn:active {
                    transform: translateY(0);
                }

                .quantity-display {
                    min-width: 100px;
                    min-height: 36px;
                    border-radius: 0;
                    border-left: 1px solid #e0e0e0 !important;
                    border-right: 1px solid #e0e0e0 !important;
                    background: white !important;
                }

                .quantity-btn:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    background: #f8f9fa !important;
                    color: #adb5bd !important;
                }

                .quantity-btn:disabled:hover {
                    background: #f8f9fa !important;
                    color: #adb5bd !important;
                    transform: none !important;
                }

                /* Responsive adjustments */
                @media (max-width: 576px) {
                    .quantity-display {
                        min-width: 80px;
                        font-size: 12px;
                    }
                    
                    .quantity-btn {
                        min-width: 32px !important;
                        min-height: 32px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default QuantityControl;
